import { FC } from "react";
import { FormQuestion } from "../utils";
import { TextField } from "@mui/material";

interface IProps {
  question: FormQuestion,
  handleChange: (questionId: string, value: string) => void,
  value: string,
  error?: string,
}

const TextareaInput: FC<IProps> = (props) => {
  const { question, handleChange, value, error } = props;

  return (
    <TextField
      className="scrollbar-small"
      variant="outlined"
      fullWidth
      size="small"
      InputProps={{ sx: { bgcolor: '#E4ECFC' } }}
      inputProps={{ maxLength: 1000 }}
      onChange={e => handleChange(question.id, e.target.value)}
      value={value}
      multiline
      rows={4}
      error={!!error}
      helperText={error}
    />
  )
}

export default TextareaInput;
